export const bookingsPublic = {
  extends: 'Page',
  flow: 'y',
  minHeight: '100vh',
  background: 'surface',
  color: 'text',

  // Header
  PublicNav: {
    tag: 'nav',
    flow: 'x',
    align: 'center space-between',
    padding: 'A C',
    borderBottom: '1px solid surfaceBorder',
    '@mobileL': { padding: 'A' },
    NavLogo: {
      extends: 'Link',
      href: '/',
      text: 'TrustLegal',
      fontSize: 'B',
      fontWeight: '800',
      color: 'green',
      textDecoration: 'none',
    },
    NavRight: {
      flow: 'x', gap: 'A', align: 'center',
      ThemeToggle: {},
      NavLogin: {
        extends: 'Link',
        href: '/login',
        text: 'შესვლა',
        fontSize: 'Z',
        color: 'textSoft',
        textDecoration: 'none',
      },
    },
  },

  // Main content
  PublicContent: {
    flow: 'y',
    align: 'center',
    flex: '1',
    padding: 'C',
    '@mobileL': { padding: 'A' },

  PublicCard: {
    flow: 'y',
    gap: 'B',
    padding: 'C',
    background: 'white',
    borderRadius: 'Z',
    width: '100%',
    maxWidth: 'H',
    border: '1px solid neutral200',
    '@mobileL': { padding: 'A' },

    FirmInfo: {
      flow: 'y',
      gap: 'Z',
      textAlign: 'center',
      FirmName: { tag: 'h1', text: '{{ lawGroupBarateli | polyglot }}', fontSize: 'B', fontWeight: '800', color: 'neutral900' },
      LawyerName: { text: '{{ ninoBarateli | polyglot }}', fontSize: 'B', color: 'neutral500' },
    },

    // ─── Select slot view ─────────────────────────
    SelectView: {
      flow: 'y',
      gap: 'A',
      show: (el, s) => s.root.publicBookingStep === 'select',

      SelectTitle: { tag: 'h2', text: '{{ selectDateTime | polyglot }}', fontSize: 'B', fontWeight: '700', color: 'neutral900' },

      WeekRow: {
        flow: 'x',
        gap: 'Z',
        flexWrap: 'wrap',
        Day1: {
          flow: 'y', gap: 'Z', flex: '1', minWidth: 'D',
          DayLabel: { text: 'ორშ 17', fontSize: 'Z', fontWeight: '600', color: 'neutral500', textAlign: 'center' },
          SlotA: { extends: 'Button', text: '09:00', padding: 'Z A', fontSize: 'Z', borderRadius: 'Z', background: 'neutral100', color: 'neutral800', border: '1px solid neutral200', textAlign: 'center', cursor: 'pointer', onClick: (e, el, s) => s.root.update({ selectedSlot: '09:00', publicBookingStep: 'form' }) },
          SlotB: { extends: 'Button', text: '10:30', padding: 'Z A', fontSize: 'Z', borderRadius: 'Z', background: 'neutral100', color: 'neutral800', border: '1px solid neutral200', textAlign: 'center', cursor: 'pointer', onClick: (e, el, s) => s.root.update({ selectedSlot: '10:30', publicBookingStep: 'form' }) },
          SlotC: { extends: 'Button', text: '14:00', padding: 'Z A', fontSize: 'Z', borderRadius: 'Z', background: 'neutral100', color: 'neutral800', border: '1px solid neutral200', textAlign: 'center', cursor: 'pointer', onClick: (e, el, s) => s.root.update({ selectedSlot: '14:00', publicBookingStep: 'form' }) },
        },
        Day2: {
          flow: 'y', gap: 'Z', flex: '1', minWidth: 'D',
          DayLabel: { text: 'სამ 18', fontSize: 'Z', fontWeight: '600', color: 'neutral500', textAlign: 'center' },
          SlotA: { extends: 'Button', text: '09:30', padding: 'Z A', fontSize: 'Z', borderRadius: 'Z', background: 'neutral100', color: 'neutral800', border: '1px solid neutral200', textAlign: 'center', cursor: 'pointer', onClick: (e, el, s) => s.root.update({ selectedSlot: '09:30', publicBookingStep: 'form' }) },
          SlotB: { extends: 'Button', text: '11:00', padding: 'Z A', fontSize: 'Z', borderRadius: 'Z', background: 'neutral100', color: 'neutral800', border: '1px solid neutral200', textAlign: 'center', cursor: 'pointer', onClick: (e, el, s) => s.root.update({ selectedSlot: '11:00', publicBookingStep: 'form' }) },
          SlotC: { extends: 'Button', text: '15:30', padding: 'Z A', fontSize: 'Z', borderRadius: 'Z', background: 'neutral100', color: 'neutral800', border: '1px solid neutral200', textAlign: 'center', cursor: 'pointer', onClick: (e, el, s) => s.root.update({ selectedSlot: '15:30', publicBookingStep: 'form' }) },
        },
        Day3: {
          flow: 'y', gap: 'Z', flex: '1', minWidth: 'D',
          DayLabel: { text: 'ოთხ 19', fontSize: 'Z', fontWeight: '600', color: 'neutral500', textAlign: 'center' },
          SlotA: { extends: 'Button', text: '10:00', padding: 'Z A', fontSize: 'Z', borderRadius: 'Z', background: 'neutral100', color: 'neutral800', border: '1px solid neutral200', textAlign: 'center', cursor: 'pointer', onClick: (e, el, s) => s.root.update({ selectedSlot: '10:00', publicBookingStep: 'form' }) },
          SlotB: { extends: 'Button', text: '13:00', padding: 'Z A', fontSize: 'Z', borderRadius: 'Z', background: 'neutral100', color: 'neutral800', border: '1px solid neutral200', textAlign: 'center', cursor: 'pointer', onClick: (e, el, s) => s.root.update({ selectedSlot: '13:00', publicBookingStep: 'form' }) },
        },
      },
    },

    // ─── Form view ────────────────────────────────
    FormView: {
      tag: 'form',
      flow: 'y',
      gap: 'A',
      show: (el, s) => s.root.publicBookingStep === 'form',

      FormTitle: {
        tag: 'h2',
        flow: 'x',
        gap: 'Z',
        align: 'center',
        fontSize: 'B',
        fontWeight: '700',
        color: 'neutral900',
        TitleText: { text: '{{ fillInfo | polyglot }}' },
        SelectedTime: { text: (el, s) => s.root.selectedSlot, color: 'neutral800', fontWeight: '700' },
      },

      NameInput: { tag: 'input', type: 'text', name: 'firstName', placeholder: '{{ firstName | polyglot }}', padding: 'Z A', fontSize: 'A', border: '1px solid neutral200', borderRadius: 'Z', color: 'neutral900', background: 'neutral50' },
      SurnameInput: { tag: 'input', type: 'text', name: 'lastName', placeholder: '{{ lastName | polyglot }}', padding: 'Z A', fontSize: 'A', border: '1px solid neutral200', borderRadius: 'Z', color: 'neutral900', background: 'neutral50' },
      PhoneInput: { tag: 'input', type: 'tel', name: 'phone', placeholder: '{{ phoneField | polyglot }}', padding: 'Z A', fontSize: 'A', border: '1px solid neutral200', borderRadius: 'Z', color: 'neutral900', background: 'neutral50' },
      EmailInput: { tag: 'input', type: 'email', name: 'email', placeholder: '{{ emailField | polyglot }}', padding: 'Z A', fontSize: 'A', border: '1px solid neutral200', borderRadius: 'Z', color: 'neutral900', background: 'neutral50' },
      DescInput: { tag: 'textarea', name: 'description', placeholder: '{{ caseDescription | polyglot }}', padding: 'Z A', fontSize: 'A', border: '1px solid neutral200', borderRadius: 'Z', color: 'neutral900', background: 'neutral50', minHeight: 'D' },

      ConfirmBtn: {
        extends: 'Button',
        text: '{{ confirmBookingPublic | polyglot }}',
        background: 'neutral900',
        color: 'neutral50',
        padding: 'Z A',
        fontSize: 'A',
        fontWeight: '600',
        borderRadius: 'Z',
        width: '100%',
        textAlign: 'center',
        cursor: 'pointer',
        onClick: (e, el, s) => {
          e.preventDefault()
          s.root.update({ publicBookingStep: 'payment' })
        },
      },
      BackBtn: {
        tag: 'a',
        text: '{{ goBack | polyglot }}',
        textAlign: 'center',
        fontSize: 'A',
        color: 'neutral500',
        cursor: 'pointer',
        textDecoration: 'none',
        onClick: (e, el, s) => s.root.update({ publicBookingStep: 'select' }),
      },
    },

    // ─── Payment view ────────────────────────────
    PaymentView: {
      flow: 'y',
      gap: 'A',
      show: (el, s) => s.root.publicBookingStep === 'payment',

      PaymentTitle: { tag: 'h2', text: 'Payment', fontSize: 'B', fontWeight: '700', color: 'neutral900' },
      PaymentDesc: { text: 'Consultation fee — pay securely to confirm your booking', fontSize: 'Z', color: 'neutral500', lineHeight: '1.5' },

      PaymentSummary: {
        flow: 'y', gap: 'Z', padding: 'A', background: 'neutral100', border: '1px solid neutral200', borderRadius: 'Z',
        SumRow1: { flow: 'x', align: 'center space-between', SumLabel: { text: 'Consultation (1 hr)', fontSize: 'Z', color: 'neutral500' }, SumVal: { text: '₾75', fontSize: 'Z', fontWeight: '600', color: 'neutral900' } },
        SumRow2: { flow: 'x', align: 'center space-between', SumLabel: { text: 'Platform fee', fontSize: 'Z', color: 'neutral500' }, SumVal: { text: '₾5', fontSize: 'Z', fontWeight: '600', color: 'neutral900' } },
        SumDivider: { height: '1', background: 'neutral200', margin: 'Y 0' },
        SumTotal: { flow: 'x', align: 'center space-between', SumLabel: { text: 'Total', fontSize: 'A', fontWeight: '700', color: 'neutral900' }, SumVal: { text: '₾80', fontSize: 'A', fontWeight: '700', color: 'neutral900' } },
      },

      PaymentMethod: {
        flow: 'y', gap: 'Z',
        MethodTitle: { text: 'Payment method', fontSize: 'Z', fontWeight: '600', color: 'neutral900' },
        MethodCards: {
          flow: 'x', gap: 'Z',
          CardOption: {
            flow: 'x', gap: 'Y', align: 'center', padding: 'Z A',
            background: 'neutral100', border: '2px solid neutral900', borderRadius: 'Z', cursor: 'pointer',
            CardDot: { width: 'Y', height: 'Y', borderRadius: '100%', background: 'neutral900' },
            CardLabel: { text: 'Card', fontSize: 'Z', fontWeight: '600', color: 'neutral900' },
          },
          BankOption: {
            flow: 'x', gap: 'Y', align: 'center', padding: 'Z A',
            background: 'neutral50', border: '1px solid neutral200', borderRadius: 'Z', cursor: 'pointer',
            CardLabel: { text: 'Bank transfer', fontSize: 'Z', color: 'neutral500' },
          },
        },
      },

      CardForm: {
        flow: 'y', gap: 'Z', width: '100%',
        CardNumberInput: { tag: 'input', type: 'text', name: 'cardNumber', placeholder: '4242 4242 4242 4242', padding: 'Z A', fontSize: 'A', border: '1px solid neutral200', borderRadius: 'Z', color: 'neutral900', background: 'neutral50', width: '100%', boxSizing: 'border-box' },
        CardRow: {
          flow: 'x', gap: 'Z', width: '100%',
          ExpiryInput: { tag: 'input', type: 'text', name: 'expiry', placeholder: 'MM / YY', padding: 'Z A', fontSize: 'A', border: '1px solid neutral200', borderRadius: 'Z', color: 'neutral900', background: 'neutral50', flex: '1', minWidth: '0' },
          CvcInput: { tag: 'input', type: 'text', name: 'cvc', placeholder: 'CVC', padding: 'Z A', fontSize: 'A', border: '1px solid neutral200', borderRadius: 'Z', color: 'neutral900', background: 'neutral50', flex: '1', minWidth: '0' },
        },
      },

      PayBtn: {
        extends: 'Button',
        text: 'Pay ₾80',
        background: 'neutral900',
        color: 'neutral50',
        padding: 'Z A',
        fontSize: 'A',
        fontWeight: '600',
        borderRadius: 'Z',
        width: '100%',
        textAlign: 'center',
        cursor: 'pointer',
        onClick: (e, el, s) => {
          e.preventDefault()
          s.root.update({ publicBookingStep: 'success' })
        },
      },
      PayBackBtn: {
        tag: 'a',
        text: '{{ goBack | polyglot }}',
        textAlign: 'center',
        fontSize: 'A',
        color: 'neutral500',
        cursor: 'pointer',
        textDecoration: 'none',
        onClick: (e, el, s) => s.root.update({ publicBookingStep: 'form' }),
      },
      SecureNote: {
        flow: 'x', gap: 'Y', align: 'center center', marginTop: 'Y',
        LockIcon: { text: '🔒', fontSize: 'Y' },
        SecureText: { text: 'Secure payment · SSL encrypted', fontSize: 'Y', color: 'neutral400' },
      },
    },

    // ─── Success view ─────────────────────────────
    SuccessView: {
      flow: 'y',
      gap: 'A',
      align: 'center center',
      textAlign: 'center',
      padding: 'C',
      show: (el, s) => s.root.publicBookingStep === 'success',

      SuccessIcon: { extends: 'Icon', icon: 'check', color: 'neutral800', width: 'C', height: 'C' },
      SuccessTitle: { tag: 'h2', text: '{{ bookingConfirmedMsg | polyglot }}', fontSize: 'B', fontWeight: '800', color: 'neutral900' },
      SuccessDetails: {
        flow: 'y',
        gap: 'Z',
        padding: 'A',
        background: 'neutral100',
        border: '1px solid neutral200',
        borderRadius: 'Z',
        width: '100%',
        DetailFirm: { text: '{{ lawGroupBarateli | polyglot }}', fontSize: 'A', color: 'neutral900', fontWeight: '600' },
        DetailLawyer: { text: '{{ ninoBarateli | polyglot }}', fontSize: 'A', color: 'neutral500' },
        DetailTime: { text: (el, s) => '{{ timeLabel | polyglot }}' + (s.root.selectedSlot || ''), fontSize: 'A', color: 'neutral800', fontWeight: '600' },
      },
    },
  },
  },

  // Footer
  PublicFooter: {
    tag: 'footer',
    flow: 'x',
    align: 'center space-between',
    padding: 'A C',
    borderTop: '1px solid surfaceBorder',
    '@mobileL': { flow: 'y', gap: 'Z', padding: 'A', align: 'center center' },
    FooterCopy: { text: '© 2026 TrustLegal', fontSize: 'Z', color: 'textMuted' },
    FooterLinks: {
      flow: 'x', gap: 'A', align: 'center',
      FooterLink1: { extends: 'Link', href: '/', text: 'მთავარი', fontSize: 'Z', color: 'textMuted', textDecoration: 'none' },
      FooterLink2: { extends: 'Link', href: '/login', text: 'შესვლა', fontSize: 'Z', color: 'textMuted', textDecoration: 'none' },
    },
  },
}
